module.exports = __webpack_public_path__ + "img/DP011C_002.37f5a849.png";